// extracted by mini-css-extract-plugin
export var columnItem = "_dw-3";
export var columnItemDraggable = "_dw-5";
export var dragHandle = "_dw-0";
export var dragHandleHovered = "_dw-1";
export var dropdown = "_dw-6";
export var dropdownContent = "_dw-8";
export var dropdownInner = "_dw-7";
export var filterDropdownHeader = "_dw-9";
export var icon = "_dw-2";
export var moveToTopButton = "_dw-4";
export var sectionDivider = "_dw-a";